/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateVehicleLocationInput = {
  vehicleId: string,
  latitude: number,
  longitude: number,
  createdAt?: string | null,
};

export type ModelVehicleLocationConditionInput = {
  vehicleId?: ModelIDInput | null,
  latitude?: ModelFloatInput | null,
  longitude?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelVehicleLocationConditionInput | null > | null,
  or?: Array< ModelVehicleLocationConditionInput | null > | null,
  not?: ModelVehicleLocationConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type vehicleLocation = {
  __typename: "vehicleLocation",
  vehicleId: string,
  latitude: number,
  longitude: number,
  createdAt: string,
  updatedAt: string,
};

export type UpdateVehicleLocationInput = {
  vehicleId: string,
  latitude?: number | null,
  longitude?: number | null,
  createdAt: string,
};

export type DeleteVehicleLocationInput = {
  vehicleId: string,
  createdAt: string,
};

export type CreateReservationStatusInput = {
  reservationId: string,
  status?: string | null,
};

export type ModelReservationStatusConditionInput = {
  reservationId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  and?: Array< ModelReservationStatusConditionInput | null > | null,
  or?: Array< ModelReservationStatusConditionInput | null > | null,
  not?: ModelReservationStatusConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type reservationStatus = {
  __typename: "reservationStatus",
  reservationId: string,
  status?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateReservationStatusInput = {
  reservationId: string,
  status?: string | null,
};

export type DeleteReservationStatusInput = {
  reservationId: string,
};

export type CreateDriverIndividualNotificationInput = {
  driverId: string,
  createdAt?: string | null,
  subject: string,
  body: string,
  eventId: string,
  isRead: boolean,
};

export type ModelDriverIndividualNotificationConditionInput = {
  driverId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  subject?: ModelStringInput | null,
  body?: ModelStringInput | null,
  eventId?: ModelStringInput | null,
  isRead?: ModelBooleanInput | null,
  and?: Array< ModelDriverIndividualNotificationConditionInput | null > | null,
  or?: Array< ModelDriverIndividualNotificationConditionInput | null > | null,
  not?: ModelDriverIndividualNotificationConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type driverIndividualNotification = {
  __typename: "driverIndividualNotification",
  driverId: string,
  createdAt: string,
  subject: string,
  body: string,
  eventId: string,
  isRead: boolean,
  updatedAt: string,
};

export type UpdateDriverIndividualNotificationInput = {
  driverId: string,
  createdAt: string,
  subject?: string | null,
  body?: string | null,
  eventId?: string | null,
  isRead?: boolean | null,
};

export type DeleteDriverIndividualNotificationInput = {
  driverId: string,
  createdAt: string,
};

export type CreateVehicleOperationScheduleUpdateManagementInput = {
  vehicleId: string,
  firstVehicleOperationScheduleId: string,
  operationDate: string,
};

export type ModelVehicleOperationScheduleUpdateManagementConditionInput = {
  vehicleId?: ModelIDInput | null,
  firstVehicleOperationScheduleId?: ModelStringInput | null,
  operationDate?: ModelStringInput | null,
  and?: Array< ModelVehicleOperationScheduleUpdateManagementConditionInput | null > | null,
  or?: Array< ModelVehicleOperationScheduleUpdateManagementConditionInput | null > | null,
  not?: ModelVehicleOperationScheduleUpdateManagementConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type vehicleOperationScheduleUpdateManagement = {
  __typename: "vehicleOperationScheduleUpdateManagement",
  vehicleId: string,
  firstVehicleOperationScheduleId: string,
  operationDate: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateVehicleOperationScheduleUpdateManagementInput = {
  vehicleId: string,
  firstVehicleOperationScheduleId?: string | null,
  operationDate: string,
};

export type DeleteVehicleOperationScheduleUpdateManagementInput = {
  vehicleId: string,
  operationDate: string,
};

export type CreateMobiPFUserTransactionInformationInput = {
  orderId: string,
  userId: string,
  ttl: number,
};

export type ModelMobiPFUserTransactionInformationConditionInput = {
  orderId?: ModelIDInput | null,
  userId?: ModelStringInput | null,
  ttl?: ModelIntInput | null,
  and?: Array< ModelMobiPFUserTransactionInformationConditionInput | null > | null,
  or?: Array< ModelMobiPFUserTransactionInformationConditionInput | null > | null,
  not?: ModelMobiPFUserTransactionInformationConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type mobiPFUserTransactionInformation = {
  __typename: "mobiPFUserTransactionInformation",
  orderId: string,
  userId: string,
  ttl: number,
  createdAt: string,
  updatedAt: string,
};

export type UpdateMobiPFUserTransactionInformationInput = {
  orderId: string,
  userId?: string | null,
  ttl?: number | null,
};

export type DeleteMobiPFUserTransactionInformationInput = {
  orderId: string,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelVehicleLocationFilterInput = {
  vehicleId?: ModelIDInput | null,
  latitude?: ModelFloatInput | null,
  longitude?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  id?: ModelIDInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelVehicleLocationFilterInput | null > | null,
  or?: Array< ModelVehicleLocationFilterInput | null > | null,
  not?: ModelVehicleLocationFilterInput | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelVehicleLocationConnection = {
  __typename: "ModelVehicleLocationConnection",
  items:  Array<vehicleLocation | null >,
  nextToken?: string | null,
};

export type ModelReservationStatusFilterInput = {
  reservationId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelReservationStatusFilterInput | null > | null,
  or?: Array< ModelReservationStatusFilterInput | null > | null,
  not?: ModelReservationStatusFilterInput | null,
};

export type ModelReservationStatusConnection = {
  __typename: "ModelReservationStatusConnection",
  items:  Array<reservationStatus | null >,
  nextToken?: string | null,
};

export type ModelDriverIndividualNotificationFilterInput = {
  driverId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  subject?: ModelStringInput | null,
  body?: ModelStringInput | null,
  eventId?: ModelStringInput | null,
  isRead?: ModelBooleanInput | null,
  id?: ModelIDInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDriverIndividualNotificationFilterInput | null > | null,
  or?: Array< ModelDriverIndividualNotificationFilterInput | null > | null,
  not?: ModelDriverIndividualNotificationFilterInput | null,
};

export type ModelDriverIndividualNotificationConnection = {
  __typename: "ModelDriverIndividualNotificationConnection",
  items:  Array<driverIndividualNotification | null >,
  nextToken?: string | null,
};

export type ModelVehicleOperationScheduleUpdateManagementFilterInput = {
  vehicleId?: ModelIDInput | null,
  firstVehicleOperationScheduleId?: ModelStringInput | null,
  operationDate?: ModelStringInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelVehicleOperationScheduleUpdateManagementFilterInput | null > | null,
  or?: Array< ModelVehicleOperationScheduleUpdateManagementFilterInput | null > | null,
  not?: ModelVehicleOperationScheduleUpdateManagementFilterInput | null,
};

export type ModelVehicleOperationScheduleUpdateManagementConnection = {
  __typename: "ModelVehicleOperationScheduleUpdateManagementConnection",
  items:  Array<vehicleOperationScheduleUpdateManagement | null >,
  nextToken?: string | null,
};

export type ModelMobiPFUserTransactionInformationFilterInput = {
  orderId?: ModelIDInput | null,
  userId?: ModelStringInput | null,
  ttl?: ModelIntInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMobiPFUserTransactionInformationFilterInput | null > | null,
  or?: Array< ModelMobiPFUserTransactionInformationFilterInput | null > | null,
  not?: ModelMobiPFUserTransactionInformationFilterInput | null,
};

export type ModelMobiPFUserTransactionInformationConnection = {
  __typename: "ModelMobiPFUserTransactionInformationConnection",
  items:  Array<mobiPFUserTransactionInformation | null >,
  nextToken?: string | null,
};

export type ModelSubscriptionVehicleLocationFilterInput = {
  vehicleId?: ModelSubscriptionIDInput | null,
  latitude?: ModelSubscriptionFloatInput | null,
  longitude?: ModelSubscriptionFloatInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionVehicleLocationFilterInput | null > | null,
  or?: Array< ModelSubscriptionVehicleLocationFilterInput | null > | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionReservationStatusFilterInput = {
  reservationId?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionReservationStatusFilterInput | null > | null,
  or?: Array< ModelSubscriptionReservationStatusFilterInput | null > | null,
};

export type ModelSubscriptionDriverIndividualNotificationFilterInput = {
  driverId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  subject?: ModelSubscriptionStringInput | null,
  body?: ModelSubscriptionStringInput | null,
  eventId?: ModelSubscriptionStringInput | null,
  isRead?: ModelSubscriptionBooleanInput | null,
  id?: ModelSubscriptionIDInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDriverIndividualNotificationFilterInput | null > | null,
  or?: Array< ModelSubscriptionDriverIndividualNotificationFilterInput | null > | null,
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionVehicleOperationScheduleUpdateManagementFilterInput = {
  vehicleId?: ModelSubscriptionIDInput | null,
  firstVehicleOperationScheduleId?: ModelSubscriptionStringInput | null,
  operationDate?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionVehicleOperationScheduleUpdateManagementFilterInput | null > | null,
  or?: Array< ModelSubscriptionVehicleOperationScheduleUpdateManagementFilterInput | null > | null,
};

export type ModelSubscriptionMobiPFUserTransactionInformationFilterInput = {
  orderId?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionStringInput | null,
  ttl?: ModelSubscriptionIntInput | null,
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionMobiPFUserTransactionInformationFilterInput | null > | null,
  or?: Array< ModelSubscriptionMobiPFUserTransactionInformationFilterInput | null > | null,
};

export type ModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type CreateVehicleLocationMutationVariables = {
  input: CreateVehicleLocationInput,
  condition?: ModelVehicleLocationConditionInput | null,
};

export type CreateVehicleLocationMutation = {
  createVehicleLocation?:  {
    __typename: "vehicleLocation",
    vehicleId: string,
    latitude: number,
    longitude: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateVehicleLocationMutationVariables = {
  input: UpdateVehicleLocationInput,
  condition?: ModelVehicleLocationConditionInput | null,
};

export type UpdateVehicleLocationMutation = {
  updateVehicleLocation?:  {
    __typename: "vehicleLocation",
    vehicleId: string,
    latitude: number,
    longitude: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteVehicleLocationMutationVariables = {
  input: DeleteVehicleLocationInput,
  condition?: ModelVehicleLocationConditionInput | null,
};

export type DeleteVehicleLocationMutation = {
  deleteVehicleLocation?:  {
    __typename: "vehicleLocation",
    vehicleId: string,
    latitude: number,
    longitude: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateReservationStatusMutationVariables = {
  input: CreateReservationStatusInput,
  condition?: ModelReservationStatusConditionInput | null,
};

export type CreateReservationStatusMutation = {
  createReservationStatus?:  {
    __typename: "reservationStatus",
    reservationId: string,
    status?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateReservationStatusMutationVariables = {
  input: UpdateReservationStatusInput,
  condition?: ModelReservationStatusConditionInput | null,
};

export type UpdateReservationStatusMutation = {
  updateReservationStatus?:  {
    __typename: "reservationStatus",
    reservationId: string,
    status?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteReservationStatusMutationVariables = {
  input: DeleteReservationStatusInput,
  condition?: ModelReservationStatusConditionInput | null,
};

export type DeleteReservationStatusMutation = {
  deleteReservationStatus?:  {
    __typename: "reservationStatus",
    reservationId: string,
    status?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateDriverIndividualNotificationMutationVariables = {
  input: CreateDriverIndividualNotificationInput,
  condition?: ModelDriverIndividualNotificationConditionInput | null,
};

export type CreateDriverIndividualNotificationMutation = {
  createDriverIndividualNotification?:  {
    __typename: "driverIndividualNotification",
    driverId: string,
    createdAt: string,
    subject: string,
    body: string,
    eventId: string,
    isRead: boolean,
    updatedAt: string,
  } | null,
};

export type UpdateDriverIndividualNotificationMutationVariables = {
  input: UpdateDriverIndividualNotificationInput,
  condition?: ModelDriverIndividualNotificationConditionInput | null,
};

export type UpdateDriverIndividualNotificationMutation = {
  updateDriverIndividualNotification?:  {
    __typename: "driverIndividualNotification",
    driverId: string,
    createdAt: string,
    subject: string,
    body: string,
    eventId: string,
    isRead: boolean,
    updatedAt: string,
  } | null,
};

export type DeleteDriverIndividualNotificationMutationVariables = {
  input: DeleteDriverIndividualNotificationInput,
  condition?: ModelDriverIndividualNotificationConditionInput | null,
};

export type DeleteDriverIndividualNotificationMutation = {
  deleteDriverIndividualNotification?:  {
    __typename: "driverIndividualNotification",
    driverId: string,
    createdAt: string,
    subject: string,
    body: string,
    eventId: string,
    isRead: boolean,
    updatedAt: string,
  } | null,
};

export type CreateVehicleOperationScheduleUpdateManagementMutationVariables = {
  input: CreateVehicleOperationScheduleUpdateManagementInput,
  condition?: ModelVehicleOperationScheduleUpdateManagementConditionInput | null,
};

export type CreateVehicleOperationScheduleUpdateManagementMutation = {
  createVehicleOperationScheduleUpdateManagement?:  {
    __typename: "vehicleOperationScheduleUpdateManagement",
    vehicleId: string,
    firstVehicleOperationScheduleId: string,
    operationDate: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateVehicleOperationScheduleUpdateManagementMutationVariables = {
  input: UpdateVehicleOperationScheduleUpdateManagementInput,
  condition?: ModelVehicleOperationScheduleUpdateManagementConditionInput | null,
};

export type UpdateVehicleOperationScheduleUpdateManagementMutation = {
  updateVehicleOperationScheduleUpdateManagement?:  {
    __typename: "vehicleOperationScheduleUpdateManagement",
    vehicleId: string,
    firstVehicleOperationScheduleId: string,
    operationDate: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteVehicleOperationScheduleUpdateManagementMutationVariables = {
  input: DeleteVehicleOperationScheduleUpdateManagementInput,
  condition?: ModelVehicleOperationScheduleUpdateManagementConditionInput | null,
};

export type DeleteVehicleOperationScheduleUpdateManagementMutation = {
  deleteVehicleOperationScheduleUpdateManagement?:  {
    __typename: "vehicleOperationScheduleUpdateManagement",
    vehicleId: string,
    firstVehicleOperationScheduleId: string,
    operationDate: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMobiPFUserTransactionInformationMutationVariables = {
  input: CreateMobiPFUserTransactionInformationInput,
  condition?: ModelMobiPFUserTransactionInformationConditionInput | null,
};

export type CreateMobiPFUserTransactionInformationMutation = {
  createMobiPFUserTransactionInformation?:  {
    __typename: "mobiPFUserTransactionInformation",
    orderId: string,
    userId: string,
    ttl: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMobiPFUserTransactionInformationMutationVariables = {
  input: UpdateMobiPFUserTransactionInformationInput,
  condition?: ModelMobiPFUserTransactionInformationConditionInput | null,
};

export type UpdateMobiPFUserTransactionInformationMutation = {
  updateMobiPFUserTransactionInformation?:  {
    __typename: "mobiPFUserTransactionInformation",
    orderId: string,
    userId: string,
    ttl: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMobiPFUserTransactionInformationMutationVariables = {
  input: DeleteMobiPFUserTransactionInformationInput,
  condition?: ModelMobiPFUserTransactionInformationConditionInput | null,
};

export type DeleteMobiPFUserTransactionInformationMutation = {
  deleteMobiPFUserTransactionInformation?:  {
    __typename: "mobiPFUserTransactionInformation",
    orderId: string,
    userId: string,
    ttl: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type GetVehicleLocationQueryVariables = {
  vehicleId: string,
  createdAt: string,
};

export type GetVehicleLocationQuery = {
  getVehicleLocation?:  {
    __typename: "vehicleLocation",
    vehicleId: string,
    latitude: number,
    longitude: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListVehicleLocationsQueryVariables = {
  vehicleId?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelVehicleLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListVehicleLocationsQuery = {
  listVehicleLocations?:  {
    __typename: "ModelVehicleLocationConnection",
    items:  Array< {
      __typename: "vehicleLocation",
      vehicleId: string,
      latitude: number,
      longitude: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetReservationStatusQueryVariables = {
  reservationId: string,
};

export type GetReservationStatusQuery = {
  getReservationStatus?:  {
    __typename: "reservationStatus",
    reservationId: string,
    status?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListReservationStatusesQueryVariables = {
  reservationId?: string | null,
  filter?: ModelReservationStatusFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListReservationStatusesQuery = {
  listReservationStatuses?:  {
    __typename: "ModelReservationStatusConnection",
    items:  Array< {
      __typename: "reservationStatus",
      reservationId: string,
      status?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDriverIndividualNotificationQueryVariables = {
  driverId: string,
  createdAt: string,
};

export type GetDriverIndividualNotificationQuery = {
  getDriverIndividualNotification?:  {
    __typename: "driverIndividualNotification",
    driverId: string,
    createdAt: string,
    subject: string,
    body: string,
    eventId: string,
    isRead: boolean,
    updatedAt: string,
  } | null,
};

export type ListDriverIndividualNotificationsQueryVariables = {
  driverId?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  filter?: ModelDriverIndividualNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListDriverIndividualNotificationsQuery = {
  listDriverIndividualNotifications?:  {
    __typename: "ModelDriverIndividualNotificationConnection",
    items:  Array< {
      __typename: "driverIndividualNotification",
      driverId: string,
      createdAt: string,
      subject: string,
      body: string,
      eventId: string,
      isRead: boolean,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetVehicleOperationScheduleUpdateManagementQueryVariables = {
  vehicleId: string,
  operationDate: string,
};

export type GetVehicleOperationScheduleUpdateManagementQuery = {
  getVehicleOperationScheduleUpdateManagement?:  {
    __typename: "vehicleOperationScheduleUpdateManagement",
    vehicleId: string,
    firstVehicleOperationScheduleId: string,
    operationDate: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListVehicleOperationScheduleUpdateManagementsQueryVariables = {
  vehicleId?: string | null,
  operationDate?: ModelStringKeyConditionInput | null,
  filter?: ModelVehicleOperationScheduleUpdateManagementFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListVehicleOperationScheduleUpdateManagementsQuery = {
  listVehicleOperationScheduleUpdateManagements?:  {
    __typename: "ModelVehicleOperationScheduleUpdateManagementConnection",
    items:  Array< {
      __typename: "vehicleOperationScheduleUpdateManagement",
      vehicleId: string,
      firstVehicleOperationScheduleId: string,
      operationDate: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMobiPFUserTransactionInformationQueryVariables = {
  orderId: string,
};

export type GetMobiPFUserTransactionInformationQuery = {
  getMobiPFUserTransactionInformation?:  {
    __typename: "mobiPFUserTransactionInformation",
    orderId: string,
    userId: string,
    ttl: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMobiPFUserTransactionInformationsQueryVariables = {
  orderId?: string | null,
  filter?: ModelMobiPFUserTransactionInformationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListMobiPFUserTransactionInformationsQuery = {
  listMobiPFUserTransactionInformations?:  {
    __typename: "ModelMobiPFUserTransactionInformationConnection",
    items:  Array< {
      __typename: "mobiPFUserTransactionInformation",
      orderId: string,
      userId: string,
      ttl: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OnCreateVehicleLocationSubscriptionVariables = {
  filter?: ModelSubscriptionVehicleLocationFilterInput | null,
};

export type OnCreateVehicleLocationSubscription = {
  onCreateVehicleLocation?:  {
    __typename: "vehicleLocation",
    vehicleId: string,
    latitude: number,
    longitude: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateVehicleLocationSubscriptionVariables = {
  filter?: ModelSubscriptionVehicleLocationFilterInput | null,
};

export type OnUpdateVehicleLocationSubscription = {
  onUpdateVehicleLocation?:  {
    __typename: "vehicleLocation",
    vehicleId: string,
    latitude: number,
    longitude: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteVehicleLocationSubscriptionVariables = {
  filter?: ModelSubscriptionVehicleLocationFilterInput | null,
};

export type OnDeleteVehicleLocationSubscription = {
  onDeleteVehicleLocation?:  {
    __typename: "vehicleLocation",
    vehicleId: string,
    latitude: number,
    longitude: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateReservationStatusSubscriptionVariables = {
  filter?: ModelSubscriptionReservationStatusFilterInput | null,
};

export type OnCreateReservationStatusSubscription = {
  onCreateReservationStatus?:  {
    __typename: "reservationStatus",
    reservationId: string,
    status?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateReservationStatusSubscriptionVariables = {
  filter?: ModelSubscriptionReservationStatusFilterInput | null,
};

export type OnUpdateReservationStatusSubscription = {
  onUpdateReservationStatus?:  {
    __typename: "reservationStatus",
    reservationId: string,
    status?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteReservationStatusSubscriptionVariables = {
  filter?: ModelSubscriptionReservationStatusFilterInput | null,
};

export type OnDeleteReservationStatusSubscription = {
  onDeleteReservationStatus?:  {
    __typename: "reservationStatus",
    reservationId: string,
    status?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateDriverIndividualNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionDriverIndividualNotificationFilterInput | null,
};

export type OnCreateDriverIndividualNotificationSubscription = {
  onCreateDriverIndividualNotification?:  {
    __typename: "driverIndividualNotification",
    driverId: string,
    createdAt: string,
    subject: string,
    body: string,
    eventId: string,
    isRead: boolean,
    updatedAt: string,
  } | null,
};

export type OnUpdateDriverIndividualNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionDriverIndividualNotificationFilterInput | null,
};

export type OnUpdateDriverIndividualNotificationSubscription = {
  onUpdateDriverIndividualNotification?:  {
    __typename: "driverIndividualNotification",
    driverId: string,
    createdAt: string,
    subject: string,
    body: string,
    eventId: string,
    isRead: boolean,
    updatedAt: string,
  } | null,
};

export type OnDeleteDriverIndividualNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionDriverIndividualNotificationFilterInput | null,
};

export type OnDeleteDriverIndividualNotificationSubscription = {
  onDeleteDriverIndividualNotification?:  {
    __typename: "driverIndividualNotification",
    driverId: string,
    createdAt: string,
    subject: string,
    body: string,
    eventId: string,
    isRead: boolean,
    updatedAt: string,
  } | null,
};

export type OnCreateVehicleOperationScheduleUpdateManagementSubscriptionVariables = {
  filter?: ModelSubscriptionVehicleOperationScheduleUpdateManagementFilterInput | null,
};

export type OnCreateVehicleOperationScheduleUpdateManagementSubscription = {
  onCreateVehicleOperationScheduleUpdateManagement?:  {
    __typename: "vehicleOperationScheduleUpdateManagement",
    vehicleId: string,
    firstVehicleOperationScheduleId: string,
    operationDate: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateVehicleOperationScheduleUpdateManagementSubscriptionVariables = {
  filter?: ModelSubscriptionVehicleOperationScheduleUpdateManagementFilterInput | null,
};

export type OnUpdateVehicleOperationScheduleUpdateManagementSubscription = {
  onUpdateVehicleOperationScheduleUpdateManagement?:  {
    __typename: "vehicleOperationScheduleUpdateManagement",
    vehicleId: string,
    firstVehicleOperationScheduleId: string,
    operationDate: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteVehicleOperationScheduleUpdateManagementSubscriptionVariables = {
  filter?: ModelSubscriptionVehicleOperationScheduleUpdateManagementFilterInput | null,
};

export type OnDeleteVehicleOperationScheduleUpdateManagementSubscription = {
  onDeleteVehicleOperationScheduleUpdateManagement?:  {
    __typename: "vehicleOperationScheduleUpdateManagement",
    vehicleId: string,
    firstVehicleOperationScheduleId: string,
    operationDate: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateMobiPFUserTransactionInformationSubscriptionVariables = {
  filter?: ModelSubscriptionMobiPFUserTransactionInformationFilterInput | null,
};

export type OnCreateMobiPFUserTransactionInformationSubscription = {
  onCreateMobiPFUserTransactionInformation?:  {
    __typename: "mobiPFUserTransactionInformation",
    orderId: string,
    userId: string,
    ttl: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateMobiPFUserTransactionInformationSubscriptionVariables = {
  filter?: ModelSubscriptionMobiPFUserTransactionInformationFilterInput | null,
};

export type OnUpdateMobiPFUserTransactionInformationSubscription = {
  onUpdateMobiPFUserTransactionInformation?:  {
    __typename: "mobiPFUserTransactionInformation",
    orderId: string,
    userId: string,
    ttl: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteMobiPFUserTransactionInformationSubscriptionVariables = {
  filter?: ModelSubscriptionMobiPFUserTransactionInformationFilterInput | null,
};

export type OnDeleteMobiPFUserTransactionInformationSubscription = {
  onDeleteMobiPFUserTransactionInformation?:  {
    __typename: "mobiPFUserTransactionInformation",
    orderId: string,
    userId: string,
    ttl: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};
